<template>
  <div
    :class="containerClasses"
    :style="{
      backgroundColor: theme?.settings?.background_color,
      width: responsive ? '100%' : `${width}px`,
      height: `${height}px`,
      borderColor: `${themeVars.primary6}!important`,
    }"
  >
    <div class="w-full">
      <h3
        class="m-0 truncate"
        :style="{
          letterSpacing: theme?.typography?.h_1?.letter_spacing,
          color: theme?.typography?.h_1?.color,
          fontSize: `${titleSize}px`,
          fontFamily: theme?.typography?.h_1?.font_family,
        }"
      >
        {{ t('canvasUI.CThemePreview.title') }}
      </h3>
      <p
        class="m-0 truncate"
        :style="{
          letterSpacing: theme?.typography?.normal_text?.letter_spacing,
          color: theme?.typography?.normal_text?.color,
          fontSize: `${textSize}px`,
          fontFamily: theme?.typography?.normal_text?.font_family,
        }"
      >
        {{ t('canvasUI.CThemePreview.normalText') }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import useThemeVars from '@lib/composables/useThemeVars'
import type { CanvasThemeRetrieve } from '@lib/types/canvasTheme'

type TextPlacement =
  | 'top-left'
  | 'top-center'
  | 'top-right'
  | 'center-left'
  | 'center'
  | 'center-right'
  | 'bottom-left'
  | 'bottom-center'
  | 'bottom-right'

const props = withDefaults(
  defineProps<{
    theme: CanvasThemeRetrieve | null
    width?: number
    height?: number
    placement?: TextPlacement
    titleSize?: number
    textSize?: number
    responsive?: boolean
  }>(),
  {
    width: 200,
    height: 120,
    placement: 'center',
    titleSize: 20,
    textSize: 14,
    responsive: false,
  },
)

const { t } = useI18n()
const themeVars = useThemeVars()

const containerClasses = computed(() => {
  const baseClasses = 'overflow-hidden border-solid'
  const flexClasses = {
    'top-left': 'items-start justify-start',
    'top-center': 'items-start justify-center',
    'top-right': 'items-start justify-end',
    'center-left': 'items-center justify-start',
    center: 'items-center justify-center',
    'center-right': 'items-center justify-end',
    'bottom-left': 'items-end justify-start',
    'bottom-center': 'items-end justify-center',
    'bottom-right': 'items-end justify-end',
  }[props.placement]

  return `${baseClasses} flex ${flexClasses}`
})
</script>
